import { Component, ChangeDetectionStrategy } from '@angular/core';
import { LoadingService } from '../../gather-services/loading.service';

@Component({
    selector: 'app-gather-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GatherLoaderComponent {
  loading = true;

  constructor(private loadingService: LoadingService) {
    this.loadingService.loading$.subscribe(val => (this.loading = val));
  }
}
